import React, { PropsWithChildren } from 'react';

export function WidgetWrapperElement({
  id,
  className,
  isArticle,
  ariaLabelledby,
  children,
}: PropsWithChildren<{ id: string; className: string; isArticle: boolean; ariaLabelledby: string }>) {
  if (isArticle) {
    return (
      <article id={id} className={className} aria-labelledby={ariaLabelledby}>
        {children}
      </article>
    );
  }

  return (
    <section id={id} className={className} aria-labelledby={ariaLabelledby}>
      {children}
    </section>
  );
}
